import type { JobPost } from "@/types/job_search/search";

export const newJobAlertPath = (post: Pick<JobPost, "urlToken" | "title" | "departmentId">) =>
  `/subscriptions/new?${new URLSearchParams({
    job_board_token: post.urlToken,
    keyword: post.title,
    ...(post.departmentId ? { department_id: String(post.departmentId) } : {}),
  })}`;
